import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import EditorialHero from "@/components/home/EditorialHero";
import JourneySection from "@/components/home/JourneySection";
import AuthorityFeature from "@/components/home/AuthorityFeature";
import CaseStudies from "@/components/home/CaseStudies";
import DiscoverySessionSection from "@/components/DiscoverySessionSection";
import FaqNoir from "@/components/home/FaqNoir";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

const Index = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const element = document.getElementById(hash.replace("#", ""));
    if (element) {
      setTimeout(() => element.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [hash]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <EditorialHero />
        <JourneySection />
        <AuthorityFeature />
        <CaseStudies />
        <DiscoverySessionSection />
        <FaqNoir />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
